// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uuVP","content":"styles_content__3S_b6"};